export enum ProgramTypes {
  AddStudent = 'Add Student',
  EsaPlusApplication = 'ESA Plus Application',
  EsaPlusRenewal = 'ESA Plus Renewal',
  Household = 'Household Application',
  OsApplication = 'OS Application',
  OsRenewal = 'OS Renewal',
  Preview = 'Preview',
  Provider = 'Provider Application',
  School = 'School Application',
}

// The short, backend-facing code for a program type (e.g. 'Household', 'AddStudent') - this is
// what gets persisted as EnrollmentProgram.ProgramType and used to filter programs by type.
// Kept as the enum's keys so it can never drift from the label text in ProgramTypes above.
export type ProgramTypeKey = keyof typeof ProgramTypes;

/** Backend EnrollmentProgram.ProgramType / EnrollmentPeriod.ProgramType code. */
export function toProgramTypeKey(programType: ProgramTypes): ProgramTypeKey {
  const entry = (Object.entries(ProgramTypes) as [ProgramTypeKey, ProgramTypes][])
    .find(([, label]) => label === programType);
  if (!entry) {
    throw new Error(`Unknown ProgramTypes value: ${programType}`);
  }
  return entry[0];
}

/** Accepts either the label ('Household Application') or the backend key ('Household'). */
export function toProgramTypes(value: string): ProgramTypes | null {
  const entry = (Object.entries(ProgramTypes) as [ProgramTypeKey, ProgramTypes][])
    .find(([key, label]) => key === value || label === value);
  return entry ? entry[1] : null;
}
